export const countries = [
  { value: "sg", label: "Singapore / SG" },
  { value: "tw", label: "Taiwan / TW" },
  { value: "my", label: "Malaysia / MY" },
  { value: "th", label: "Thailand / TH" },
  { value: "jp", label: "Japan / JP" },
];
export default countries;